import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(
    private Auth: AuthenticationService,
  ) { }

  role:any = "";
  permision : string[] = [];
  currentuser : any = {};

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    this.cekuser();
    this.permision = this.currentuser.permision;

  }

  cekuser() {

    const currentUser:any = this.Auth.currentUserValue;
    // console.log(currentUser);
    if (currentUser != null) {
          
      if (currentUser.role.roleName) {
          // authorised so return true
          // this.router.navigate(['']);
          this.role = currentUser.role.roleName;
      }
      
    }
  }

  MyPermission(p)
  {
    if (this.permision.indexOf(p) > -1){
      return true;
    }else{
        return false;
    }
  }
}
